import React, { useEffect } from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import converter from "number-to-words";
import {
  enable as enableDarkMode,
  disable as disableDarkMode,
} from "darkreader";
import { regularMonths, copticMonths } from "../utilities/date";
import logo from "../assets/image/radiusLogo.png";
import sun from "../assets/image/sun.svg";
import moon from "../assets/image/moon.svg";
import refresh from "../assets/image/refresh-cw.svg";

export default function Left() {
  const isDarkMode = useStoreState((state) => state.isDarkMode);
  const isCopticCal = useStoreState((state) => state.isCopticCal);
  const dates = useStoreState((state) => state.dates);
  const setCopticCal = useStoreActions((action) => action.setCopticCal);
  const setDarkMode = useStoreActions((action) => action.setDarkMode);
  const activeDate = useStoreState((state) => state.activeDate);

  useEffect(() => (!isDarkMode ? disableDarkMode() : enableDarkMode()), [
    isDarkMode,
  ]);

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return (
    <div className="left">
      <div className="logo-container">
        <img src={logo} alt="logo" className="logo" />
      </div>

      <div className="left-dates">
        <div className="primary">
          <div className="day">
            <span>
              {activeDate.normalDate &&
                days[
                  new Date(
                    `${activeDate.normalDate.year}/${
                      activeDate.normalDate.month + 1
                    }/${activeDate.normalDate.date}`
                  ).getDay()
                ]}
            </span>
          </div>
          <div className="date">
            <span>{converter.toOrdinal(dates?.date || 0)}</span>
          </div>
          <div className="month">
            <span>
              {isCopticCal
                ? copticMonths[dates.month]
                : regularMonths[dates.month]}
            </span>
          </div>
        </div>

        <div className="secondary">
          <div className="day">
            <span>
              {activeDate.normalDate &&
                days[
                  new Date(
                    `${activeDate.normalDate.year}/${
                      activeDate.normalDate.month + 1
                    }/${activeDate.normalDate.date}`
                  ).getDay()
                ]}
            </span>
          </div>
          <div className="date">
            <span>
              {isCopticCal && activeDate.normalDate !== null
                ? converter.toOrdinal(activeDate.normalDate?.date || 0)
                : converter.toOrdinal(activeDate.copticDate?.date || 0)}
            </span>
          </div>
          <div className="month">
            <span>
              {isCopticCal && activeDate.normalDate !== null
                ? regularMonths[activeDate.normalDate?.month]
                : copticMonths[activeDate.copticDate?.month]}
            </span>
          </div>
        </div>
      </div>

      <div className="left-footer">
        <div>
          <img
            src={isDarkMode ? sun : moon}
            alt={isDarkMode ? sun : moon}
            onClick={() => setDarkMode(!isDarkMode)}
          ></img>
        </div>
        <div>
          <img
            src={refresh}
            alt="refresh"
            onClick={() => setCopticCal(!isCopticCal)}
          ></img>
        </div>
      </div>
    </div>
  );
}
